import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { TransmittalsPage } from '@/features/design/transmittals-page';

const searchSchema = z.object({ transmittal: z.string().optional().catch(undefined) });

export const Route = createFileRoute('/_app/projects/$projectId/design/transmittals')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <TransmittalsPage projectId={projectId} transmittalId={search.transmittal} />;
}
